import React, { useState, useEffect, } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
    GrayButton,
    NomalButton
} from '../../css/CSS.js';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import UndoIcon from '@mui/icons-material/Undo';

export default function AccountManagementImportDialog(props) {
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false)
        props.cancelClick();
    };

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])


    const handleOpen = () => {
        props.confirmClick();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            closeAfterTransition={false}
        >
            <Grid container direction="row"
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    p: 3,
                    backgroundColor: "#1976d2",
                }}>
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: '2rem', color: '#ffffff', py: 0 }}>
                    {"請負担当者一括登録"}
                </DialogTitle>
            </Grid>
            {props.errorType === null ?
                <div>
                    <DialogContent sx={{ px: 10, py: 5 }}>
                        <Typography sx={{ fontSize: '1.5rem' }}>
                            {props.importFileLength}件のデータを登録します。<br />
                            よろしいですか？
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Grid container
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 2
                            }}>
                            <GrayButton variant="contained" size="large" onClick={handleClose}
                                sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                                <UndoIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                キャンセル
                            </GrayButton>
                            <NomalButton variant="contained" size="large" onClick={handleOpen}
                                sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                                <CheckIcon sx={{ mr: 2, fontSize: '2rem' }} />確定
                            </NomalButton>
                        </Grid>
                    </DialogActions>
                </div>
                :
                props.errorType === 0 ?
                    <div>
                        <DialogContent sx={{ px: 8, py: 5 }}>
                            <Typography sx={{ fontSize: '1.5rem', pb: 2 }}>
                                ヘッダー行に誤りがあります。<br />
                                下記項目を順番通りに修正してください。
                            </Typography>
                            <Grid container
                                direction='column'
                                sx={{
                                    mb: 2
                                }}>
                                {props.errorContent?.map((content, index) => {
                                    return (
                                        <Typography sx={{ fontSize: '1.2rem' }} key={index}>
                                            ・{content}
                                        </Typography>
                                    )
                                }
                                )}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Grid container
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mb: 2
                                }}>
                                <GrayButton variant="contained" size="large" onClick={handleClose}
                                    sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                                    <ClearIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                    閉じる
                                </GrayButton>
                            </Grid>
                        </DialogActions>
                    </div> :
                    props.errorType === 1 ?
                        <div>
                            <DialogContent sx={{ px: 8, py: 5 }}>
                                <Typography sx={{ fontSize: '1.5rem', pb: 2 }}>
                                    {props.errorContent[0]}行目に不備があります。
                                </Typography>
                                <Typography sx={{ fontSize: '1.5rem', }}>
                                    {props.errorContent[1]}
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Grid container
                                    sx={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        mb: 2
                                    }}>
                                    <GrayButton variant="contained" size="large" onClick={handleClose}
                                        sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                                        <ClearIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                        閉じる
                                    </GrayButton>
                                </Grid>
                            </DialogActions>
                        </div> :
                        props.errorType === 2 ?
                            <div>
                                <DialogContent sx={{ px: 8, py: 5 }}>
                                    <Typography sx={{ fontSize: '1.5rem', pb: 2 }}>
                                        請負者Noがファイル内で重複しています。
                                    </Typography>
                                    <Typography sx={{ fontSize: '1.5rem', }}>
                                        該当請負者No：{props.errorContent[0]}<br />
                                        ・{props.errorContent[1]}行目<br />
                                        ・{props.errorContent[2]}行目
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Grid container
                                        sx={{
                                            justifyContent: "center",
                                            alignItems: "center",
                                            mb: 2
                                        }}>
                                        <GrayButton variant="contained" size="large" onClick={handleClose}
                                            sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                                            <ClearIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                            閉じる
                                        </GrayButton>
                                    </Grid>
                                </DialogActions>
                            </div>
                            :
                            null
            }
        </Dialog>
    )
}